export const HOME = "Home",
  ABOUT = "About",
  PROJECTS = "Projekte",
  ACQUISITIONS = "Ankaufsprofil",
  NEWS = "News",
  JOBS = "Jobs",
  CONTACT = "Kontakt",
  IMPRESSUM = "Impressum",
  PRIVACY = "Datenschutz",
  PRESS = "Pressemitteilung";

export const HOME_TITLE = "NEW.SPACE",
  ABOUT_TITLE = "Das sind wir",
  PROJECTS_TITLE = "Unsere Immobilien",
  ACQUISITIONS_TITLE = "Wir kaufen an",
  NEWS_TITLE = "Neuigkeiten",
  JOBS_TITLE = "new.space als Arbeitgeber",
  CONTACT_TITLE = "Ansprechpartner";

export const HOME_PATH = "/",
  ABOUT_PATH = "/about",
  PROJECTS_PATH = "/projekte/",
  ACQUISITIONS_PATH = "/ankaufsprofil",
  NEWS_PATH = "/news/",
  JOBS_PATH = "/jobs",
  CONTACT_PATH = "/kontakt";

export const navigationItems = [
  { page: HOME, url: HOME_PATH, title: HOME_TITLE },
  { page: ABOUT, url: ABOUT_PATH, title: ABOUT_TITLE },
  { page: PROJECTS, url: PROJECTS_PATH, title: PROJECTS_TITLE },
  { page: ACQUISITIONS, url: ACQUISITIONS_PATH, title: ACQUISITIONS_TITLE },
  { page: NEWS, url: NEWS_PATH, title: NEWS_TITLE },
  { page: JOBS, url: JOBS_PATH, title: JOBS_TITLE },
  { page: CONTACT, url: CONTACT_PATH, title: CONTACT_TITLE },
];

export const PROJECT = "Projekt";

export default navigationItems;
